
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  // Registering immediately rather than waiting for window.load to ensure we capture as much as possible
  navigator.serviceWorker.register('./sw.js')
    .then(reg => {
      console.log('ServiceWorker active scope:', reg.scope);
      
      // If there's an updated worker, try to activate it
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('New content available; please refresh.');
            }
          });
        }
      });
    })
    .catch(err => {
      console.warn('ServiceWorker registration error:', err);
    });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
